import { type AdSource } from '@kijiji/generated/graphql-types'

import { ListingDetails } from '@/components/srp/listing-card/listing-details'
import { RichCardContentContainer } from '@/features/listing/components/rich-card/styled'

export const RichCardContent = ({
  adSource,
  sortingDate,
  locationName,
  proximity,
  rating,
  verified,
}: {
  adSource?: AdSource
  sortingDate?: string | null
  locationName?: string | null
  proximity?: string
  rating?: number | null
  verified?: boolean | null
}) => (
  <RichCardContentContainer>
    <ListingDetails
      sortingDate={sortingDate}
      locationName={locationName}
      proximity={proximity}
      dateFormat="short"
      listingAdSource={adSource}
      rating={rating}
      verified={verified}
    />
  </RichCardContentContainer>
)
